import ContractInfo from './ContractInfo.vue';

export default ContractInfo;
